<template>
  <span class="startBtn" v-on:mousedown.prevent="start" v-on:touchstart.prevent="start" v-on:mouseup="isActive=false" v-on:mouseout="isActive=false" v-on:touchend="isActive=false" v-bind:class="{active: isActive}">MouseDown OR TouchStart</span>
</template>
<script>
export default {
  name: 'MouseTouchStart',
  data(){
    return {
      isActive: false
    }
  },
  methods:{
    start(ev){
      console.log(ev.type);
      this.isActive = true;
    }
  }
}
</script>
<style>
.startBtn{
  display:inline-block;
  width:250px;
  height:40px;
  line-height:40px;
  border:1px solid #aaaaaa;
  background-color: #00A;
  cursor: pointer;
  color:white;
  font-weight: bold;
}
.startBtn.active{
  background-color:#33A;
}
</style>